import { ISupportClientInfo } from 'models/chat'

/**
 * Данные о клиенте для поддержки: браузер и систему сервер разберёт из
 * User-Agent, а пояс, язык и экран знает только сама страница.
 */
export const getSupportClientInfo = (): ISupportClientInfo | undefined => {
  try {
    return {
      app: 'SELLER_CABINET',
      app_version: process.env.REACT_APP_VERSION || undefined,
      page_url: window.location.href.slice(0, 500),
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      // getTimezoneOffset у Москвы даёт -180, оператору привычнее +180
      timezone_offset: -new Date().getTimezoneOffset(),
      language: navigator.language,
      screen: `${window.screen.width}x${window.screen.height}, окно ${window.innerWidth}x${window.innerHeight}`
    }
  } catch {
    return undefined
  }
}
